import type { EventPhoto, GalleryGroup } from '../../types';
import type { ResponseWithType } from './types';

type GalleryGroupRest = Omit<GalleryGroup, 'pageNumber' | 'photos'> & {
  data: EventPhoto[];
  page: string;
};

const galleryGroup = ({
  data: { data, page, hasMorePages, totalPages },
}: ResponseWithType<GalleryGroupRest>): GalleryGroup => ({
  photos: [...data],
  pageNumber: parseInt(page, 0),
  hasMorePages,
  totalPages,
});
export default galleryGroup;
